import {
  Delete,
  Get,
  getAPIUrl,
  Post,
  Put,
} from "../../../ApiServices/apiMethod";
import { HomePageService } from "../../../ApiServices/Axios/Index";

export const UsersEndpoint = {
  getUsers: `/admin/user/list`,
  deleteUser: `/admin/user/delete/`,
  toggleStatus: `/admin/user/toggle/`,
};

export const getUsers = (param = "") => {
  const url = getAPIUrl(UsersEndpoint.getUsers, param);
  return Get(HomePageService, url, true);
};

export const deleteUser = (param = "") => {
  const url = getAPIUrl(UsersEndpoint.deleteUser, param);
  return Delete(HomePageService, url, param);
};

export const toggleStatus = (data, param = "") => {
  const url = getAPIUrl(UsersEndpoint.toggleStatus, param);
  return Put(HomePageService, url, data, true);
};